import { memo, useMemo } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import AdAccount from './adAccounts/page'
import Payments from './payments'
import { logos } from '@/utils/sidebar-menu-icon'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'

const Settings = memo(() => {
    const theme = localStorage.getItem('theme') || 'light'
    const location = useLocation()
    const navigate = useNavigate()
    const { id: campaignId } = useParams()

    const currentTab = useMemo(() => {
        if (location.pathname.includes('/settings/payments')) return 'payments'
        return 'account'
    }, [location.pathname])

    const handleTabChange = (tab) => {
        const routeByTab = {
            account: `/campaigns/media-buying/${campaignId}/settings/ad-account`,
            payments: `/campaigns/media-buying/${campaignId}/settings/payments`,
        }

        const route = routeByTab[tab]
        if (route && route !== location.pathname) {
            navigate(route)
        }
    }

    return (
        <div className="mt-3">
            <div className="d-flex align-items-center mb-3 ps-4">
                <img src={logos.MediaSettings.dark} alt="Media Settings Icon" style={imageStyles} />
                <h2 className={`mb-0 ${theme === 'light' ? 'media-buying-light-text' : 'media-buying-dark-text'}`}>
                    Media Buying Settings
                </h2>
            </div>

            <Tabs value={currentTab} onValueChange={handleTabChange} className="tw:w-full tw:gap-1">
                <TabsList className="tw:bg-transparent tw:gap-2 tw:ml-6">
                    <TabsTrigger
                        value="account"
                        className={cn(
                            'tw:text-base tw:font-semibold tw:border-0 tw:px-[30px] tw:py-5 tw:data-[state=active]:border-b-4 tw:data-[state=active]:!border-blue-500',
                            'tw:border-b tw:border-transparent tw:hover:border-white',
                        )}
                    >
                        Ad Account
                    </TabsTrigger>
                    <TabsTrigger
                        value="payments"
                        className={cn(
                            'tw:text-base tw:font-semibold tw:border-0 tw:px-[30px] tw:py-5 tw:data-[state=active]:border-b-4 tw:data-[state=active]:!border-blue-500',
                            'tw:border-b tw:border-transparent tw:hover:border-white',
                        )}
                    >
                        Payments
                    </TabsTrigger>
                </TabsList>
                <TabsContent value="account">
                    <div className="tw:w-full tw:border-t tw:border-border">
                        <div className="tw:p-6">
                            <AdAccount />
                        </div>
                    </div>
                </TabsContent>
                <TabsContent value="payments">
                    <div className="tw:w-full tw:border-t tw:border-border">
                        <div className="tw:p-6">
                            <Payments />
                        </div>
                    </div>
                </TabsContent>
            </Tabs>
        </div>
    )
})

const imageStyles = {
    maskRepeat: 'no-repeat',
    width: '32px',
    height: '32px',
    marginRight: '8px',
    display: 'inline-block',
    WebkitMaskSize: 'contain',
    maskSize: 'contain',
    WebkitMaskPosition: 'center',
    maskPosition: 'center',
}

export default Settings
